module.exports = __webpack_public_path__ + "media/images/lb/619-ac5b60c77dfb1b3e25b8fae45b58c38d.svg";